import contentDisposition from 'content-disposition';
import fileDownload from 'js-file-download';

export default {
  namespaced: true,
  state: {},
  actions: {
    downloadFile(_, action) {
      const { data } = action.payload;
      const { headers } = action.payload;

      const filenameString = headers['content-disposition'];
      const { filename } = contentDisposition.parse(filenameString).parameters;

      const contentType = 'application/octet-stream';
      const blob = new Blob([data], { type: contentType });

      fileDownload(blob, filename);
    },
  },
};
